import {type FC, useMemo} from 'react';
import {cn} from '../../../../../../lib/classname';
import {CommonLink} from '../../../../../../shared/components/CommonLink';
import {
  type SegmentedControlItem,
  SegmentedControls,
} from '../../../../../../shared/components/SegmentedControls';
import {
  COLUMNS_BY_ALL_CATEGORIES,
  COLUMNS_COMPANY_LIST,
  COLUMNS_SPONSORED,
  COLUMNS_TOP,
} from '../../routes';
import type {ListType} from '../list-type';
import {Button} from './Button';
import {Categories} from './Categories';
import {CompanyFilterByIndustry} from './CompanyFIlterByIndustry';
import {CompanySearchInput} from './CompanySearch';
import {GssktResearchLink} from './GssktResearchLink';
import {SelectRankingMetric} from './SelectRankingMetric';

type Props = {
  className?: string;
  listType: ListType;
};
export const Control: FC<Props> = ({className, listType}) => {
  const hideTabs = useMemo(() => {
    return listType === 'category';
  }, [listType]);

  const segmentedControlItems = useMemo(() => {
    const items: Required<SegmentedControlItem>[] = [
      {content: 'おすすめ', value: 'recommended', href: COLUMNS_TOP},
      {
        content: 'カテゴリ',
        value: 'category',
        href: COLUMNS_BY_ALL_CATEGORIES,
      },
      {
        content: '企業コラム',
        value: 'sponsored',
        href: COLUMNS_SPONSORED,
      },
      {content: '企業一覧', value: 'company', href: COLUMNS_COMPANY_LIST()},
    ];
    return items;
  }, []);

  return (
    <div
      className={cn(
        'bg-white flex flex-col gap-12 py-12 border-b border-black-5',
        'pc:bg-transparent pc:gap-8 pc:p-0 pc:border-none',
        className,
      )}
    >
      {!hideTabs && (
        <div
          className={cn(
            'hidden pc:flex',
            'items-center justify-between bg-white shadow-inner rounded-16 overflow-hidden',
          )}
        >
          <div
            className={cn(
              'flex w-full items-center justify-between gap-x-16 px-16 py-12',
            )}
          >
            <ul className={cn('flex items-center gap-16')}>
              <li>
                <Button
                  active={listType === 'recommended'}
                  as={CommonLink}
                  href={COLUMNS_TOP}
                >
                  おすすめ
                </Button>
              </li>
              <li>
                <Button
                  active={listType === 'category'}
                  as={CommonLink}
                  href={COLUMNS_BY_ALL_CATEGORIES}
                >
                  カテゴリ
                </Button>
              </li>
              <li>
                <Button
                  active={listType === 'sponsored'}
                  as={CommonLink}
                  href={COLUMNS_SPONSORED}
                >
                  企業コラム
                </Button>
              </li>
              <li>
                <Button
                  active={listType === 'company'}
                  as={CommonLink}
                  href={COLUMNS_COMPANY_LIST()}
                >
                  企業一覧
                </Button>
              </li>
              {listType === 'recommended' && (
                <li>
                  <GssktResearchLink />
                </li>
              )}
            </ul>

            {listType === 'ranking' && <SelectRankingMetric />}
            {listType === 'company' && (
              <CompanySearchInput className="w-full max-w-[420px]" />
            )}
          </div>
        </div>
      )}

      <div
        className={cn(
          'flex pc:hidden',
          'flex-col gap-12 justify-between items-center px-16',
        )}
      >
        <SegmentedControls
          className="w-full"
          value={listType}
          items={segmentedControlItems}
        />
        {listType === 'ranking' && <SelectRankingMetric className="ml-auto" />}
        {listType === 'company' && <CompanySearchInput className="w-full" />}
      </div>

      {listType === 'category' && <Categories />}
      {listType === 'company' && <CompanyFilterByIndustry />}
    </div>
  );
};
